export default {
    'zh-cn': {
        'aidite_Investor_Relations': '爱迪特投资者关系',
        common: {
            'previous_page': '上一页',
            'next_page': '下一页',
            'back_to_top': '返回顶部',
            'cancel': '取消',
        },
        'menu': {
            'home': '首页',
            'business_rules': '公司治理',
            'business_rules_intro': '公司治理介绍',
            'structural': '董监高',
            'supervisors': '治理委员会',
            'sustain': '可持续发展',
            'quote': '股价信息',
            'investment': '投关互动',
            'news': '投关新闻',
            'newsDetail': '新闻详情',
            'calendar': '日历',
            'analyst': '分析师',
            'report': '券商研报',
            'presentation': '演示材料',
            'quarterly_performance': '公告',
            'regular_report': '定期报告',
            'announcement': '临时公告',
            'question': '投资者服务',
            'faq': '常见问题',
            'contact': '联系方式'
        },
        'business_rules': {
            'content1': '我们始终致力于建立健全的公司治理机制，以确保公司在能够高效、透明地运作，并持续提升其价值和声誉。',
            'content2': '我们建立了严格的董事会监督和决策机制，并且通过股东大会和监事会的参与，进一步确保公司治理的透明度和有效性。公司董事会由经验丰富、具有多元化背景的成员组成，他们具备深厚的行业知识及广泛的管理经验。董事会及各委员会在公司战略制定、财务审计、风险管理等方面发挥着关键作用，确保各项决策符合公司长远发展的战略方向和利益最大化的原则。',
            'director': '董事',
            'executive': '高管',
            'strategic_committee': '战略委员会',
            'audit_committee': '审计委员会',
            'nomination_committee': '提名委员会',
            'compensation_committee': '薪酬与考核委员会',
            'chairman': '董事长',
            'independent_director': '独立董事',
            'general_manager': '总经理',
            'vice_general_manager': '副总经理',
            'board_secretary': '副总经理兼董事会秘书',
            'financial_director': '财务总监',
            'supervisor_chairman': '主任委员',
            'supervisor_member': '委员',
        },
        quote: {
            'main_index': '主要指标',
            'k_line': 'K线图',
            'candle': 'K线',
            'day': '日',
            'week': '周',
            'month': '月',
            'dividends': '分红送配',
            'margin_funds': '融资融券',
            'northbound-funds': '北上资金',
            'announced': '公告日',
            'ex-date': '除尽日',
            'record-date': '登记日',
            'payment-date': '派息日',
            'dividend-scheme': '分红(每10股税前)',
            'recent-dividend-scheme': '最近分红(每10股)',
            'bonus-issue/by-reserve': '送股/转增(每10股)',
            'trade_date': '交易日期',
            'margin_loan_outstanding': '本日融资余额(元)',
            'margin_purchases': '本日融资买入额(元)',
            'securities_sold_short_outstanding': '本日融券余量(股)',
            'short_sales': '本日融券卖出量(股)',
            'market_value_short_positions_outstanding': '融券余量金额(元)',
            'total_margin_balance': '融资融券余额(元)',
            // 北上资金
            'holding-date': '持股日期',
            'closing-price': '当日收盘价(元)',
            'daily-change': '当日涨跌幅(%)',
            'number-of-shares-held-(shares)': '持股数量(股)',
            'number-of-shares-held-shares-unit': '持股数量({value}股)',
            'holding-percentage': '持股数量占比(%)',
            'proportion': '占比',

            // 股票行情指标
            'chg': '涨跌额',
            '%Chg': '涨跌幅',
            'high': '最高',
            'low': '最低',
            'P/E': '市盈率(TTM)',
            'clear-P/E': '市盈率',
            'P/B': '市净率',
            'turnover': '成交额',
            'volume': '成交量',
            'market-cap': '总市值',
            'market-cap-in-hk09606': '总市值（HKD）',
            'float-cap': '流通值',

            'until': '截止至',
            'UTC': '北京时间',
            // 股票行情-K线图
			'k-high': '最高价',
			'k-low': '最低价',
			'k-turnover': '交易额',
			'k-volume': '交易量',
			'k-opening': '开盘价',
			'k-closing': '收盘价',
            'quotes-data': '行情数据',
        },

        'investment': {
            'appointment': '预约调研',
            'survey': '扫码预约调研',
        },
        'analyst': {
            'institution': '机构',
            'name': '分析师',
        },
        'quarterly_performance': {
            'overview': '爱迪特(秦皇岛)科技股份有限公司成立于2007年3月15日,是一家集口腔材料与设备研发、生产、服务及数字化综合解决方案于一体的全球齿科服务商。Aidite荣获一百余项专利授权,业务遍及全球,分别在美国、德国、韩国、日本设有一家子公司服务海外客户。公司累积服务义齿加工厂、门诊及口腔医院累计超过1万家,大约有9000多万名终端患者享受到了Aidite优质化服务。',
            'annual_report': '年度报告',
            'half_year_report': '半年度报告',
            'third_quarter_report': '三季度报',
            'first_quarter_report': '一季度报',
            'q4_report': '年报',
            'q2_report': '半年报',
            'q3_report': '三季度报告',
            'q1_report': '一季度报告',
            'download': '下载',
        },
        'announcement': {
            'all': '全部',
            'type': '按类型',
            'search': '请输入关键词搜索',
        },
        'question': {
            'expand': '展开',
            'collapse': '收起',
        },
        'contact': {
            'phone': '联系电话',
            'email': '电子邮箱',
            'address': '公司地址',
            'address_content': '河北省秦皇岛市经济技术开发区都山路9号',
            'fax': '传真',
            'tel': '拨打电话'
        },
        'report': {
            // 券商研报 - 评级
            'BUY': '买入',
            'HOLD': '中性',
            'SELL': '卖出',
        },
    },
    'en': {
        'aidite_Investor_Relations': 'Aidite Investor Relations',
        common: {
            'previous_page': 'Previous',
            'next_page': 'Next',
            'back_to_top': 'Top',
            'cancel': 'Cancel',
        },
        'menu': {
            'home': 'Home',
            'business_rules': 'Governance',
            'business_rules_intro': 'Corporate Governance Overview',
            'structural': 'Governance Composition',
            'supervisors': 'Committee Composition',
            'sustain': 'ESG',
            'quote': 'Stock Information',
            'investment': 'IR Interaction',
            'news': 'Media Releases',
            'newsDetail': 'News Detail',
            'calendar': 'Events Calendar',
            'analyst': 'Analyst Coverage',
            'report': 'Research Report',
            'presentation': 'Presentation Materi',
            'quarterly_performance': 'Announcement',
            'regular_report': 'Periodic Reports',
            'announcement': 'Ad Hoc Reports',
            'question': 'Investor Services',
            'faq': 'Q&A',
            'contact': 'Contacts'
        },
        'business_rules': {
            'content1': "We are consistently committed to establishing and strengthening a sound corporate governance mechanism to ensure the company's efficient and transparent operation, while continuously enhancing its value and reputation.",
            'content2': "We have established rigorous oversight and decision-making mechanisms for the Board of Directors. Through the participation of the General Meeting of Shareholders , we further ensure the transparency and effectiveness of corporate governance. The company's Board of Directors is composed of experienced members with diverse backgrounds, who possess profound industry knowledge and extensive management experience. The Board and its committees play key roles in areas such as corporate strategy formulation, financial auditing, and risk management, ensuring that all decisions align with the company's long-term strategic direction and the principle of maximizing interests.",
            'director': 'Director',
            'executive': 'Senior Management',
            'strategic_committee': 'Strategy Committee',
            'audit_committee': 'Audit Committee',
            'nomination_committee': 'Nomination Committee',
            'compensation_committee': 'Remuneration and Assessment Committee',

            'chairman': 'Chairman of the board',
            'independent_director': 'Independent Director',
            'general_manager': 'CEO',
            'vice_general_manager': 'Vice President',
            'board_secretary': 'Vice President & Board Secretary',
            'financial_director': 'CFO',
            'supervisor_chairman': 'Chairman',
            'supervisor_member': 'Member',
        },
        quote: {
            'main_index': 'Financial Indicators',
            'k_line': 'Candle',
            'candle': 'Candle',
            'day': 'Day',
            'week': 'Week',
            'month': 'Month',
            'dividends': 'Dividends',
            'margin_funds': 'Margin Trading',
            'northbound-funds': 'Stock Connect',
            'announced': 'Announced',
            'ex-date': 'Ex-Date',
            'record-date': 'Record Date',
            'payment-date': 'Payment Date',
            'dividend-scheme': 'Dividend Scheme (Per 10 shares)',
            'recent-dividend-scheme': 'Recent Dividends (Per 10 shares)',
            'bonus-issue/by-reserve': 'Bonus Issue/by Reserve (Per 10 shares)',
            'trade_date': 'Trade Date',
            'margin_loan_outstanding': 'Margin Loan Outstanding',
            'margin_purchases': 'Margin Purchases',
            'securities_sold_short_outstanding': 'Securities Sold Short Outstanding',
            'short_sales': 'Short Sales',
            'market_value_short_positions_outstanding': 'Market Value of Short Positions Outstanding',
            'total_margin_balance': 'Total Margin Balance',
            // 北上资金
            'holding-date': 'Date',
            'closing-price': 'Close',
            'daily-change': '%Chg',
            'number-of-shares-held-(shares)': 'Shares Held',
            'number-of-shares-held-shares-unit': 'Shares Held({value})',
            'holding-percentage': 'Ratio Shares',
            'proportion': 'Ratio Shares',


            // 股票行情指标
            'chg': 'Chg',
            '%Chg': '%Chg',
            'high': 'High',
            'low': 'Low',
            'P/E': 'P/E(TTM)',
            'clear-P/E': 'P/E',
            'P/B': 'P/B',
            'turnover': 'Turnover',
            'volume': 'Volume',
            'market-cap': 'Market Cap',
            'market-cap-in-hk09606': 'Market Cap (HKD)',
            'float-cap': 'Float Cap',

            'until': 'Updated',
            'UTC': 'UTC+8',
            
             // 股票行情-K线图
            'k-high': 'High',
			'k-low': 'Low',
			'k-turnover': 'Turnover',
			'k-volume': 'Volume',
			'k-opening': 'Open',
			'k-closing': 'Close',
            'quotes-data': 'Quotes Data',
        },
        'investment': {
            'appointment': 'Investor Visit',
            'survey': 'Survey'
        },
        'analyst': {
            'institution': 'Organization',
            'name': 'Analyst Coverage',
        },
        'quarterly_performance': {
            'overview': "Aidite (Qinhuangdao) Technology Co., Ltd., established on March 15, 2007, is global dental service provider that integrates the R&D, production, and service of dental materials and equipment with comprehensive digital solutions. Aidite has been granted over 100 patents and serves customers worldwide through its subsidiaries in the United States, Germany, South Korea, and Japan. The company has provided services to more than 10,000 dental laboratories, clinics, and hospitals, benefiting approximately over 90 million end-patients with Aidite's high-quality solutions.",
            'annual_report': 'Annual Report',
            'half_year_report': 'H1 Report',
            'third_quarter_report': 'Q3 Report',
            'first_quarter_report': 'Q1 Report',
            'q4_report': 'Annual Earnings Report',
            'q2_report': 'H1 Earnings Report',
            'q3_report': 'Q3 Earnings Report',
            'q1_report': 'Q1 Earnings Report',
            'download': 'Download',
        },
        'announcement': {
            'all': 'All',
            'type': 'Type',
            'search': 'search',
        },
        'question': {
            'expand': 'Display',
            'collapse': 'Hide',
        },
        'contact': {
            'phone': 'Tel',
            'email': 'E-mail',
            'address': 'Company Address',
            'address_content': 'No. 9 Dushan Road, Qinhuangdao Economic and Technological Development Zone, Hebei Province',
            'fax': 'Fax',
            'tel': 'Tel'
        },
        'report': {
            // 券商研报 - 评级
            'BUY': 'BUY',
            'HOLD': 'HOLD',
            'SELL': 'SELL',
        },
    }
}